<template>
    <div class="package-faq">
        <div class="faq-heading">Common Questions</div>
        <div class="faq-item" v-for="(faq, index) in faqs" :key="'faq-' + index">
            <div class="faq-question" @click="toggle(index)">
                <div>{{ faq.q }}</div>
                <i class="far fa-fw" :class="open === index ? 'fa-minus' : 'fa-plus'"></i>
            </div>
            <div class="faq-answer" v-if="open === index">{{ faq.a }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PackageFaq",
        props: {
            faqs: {type: Array, required: true}
        },
        data: function() {
            return {
                open: -1
            };
        },
        methods: {
            toggle(index) {
                this.open = this.open === index ? -1 : index;
            }
        },
        watch: {
            // A new question set (step change) closes the open answer
            faqs() {
                this.open = -1;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .package-faq {
        .faq-heading {
            font-size: 0.75rem;
            font-weight: bold;
            letter-spacing: 0.06em;
            text-transform: uppercase;
            color: #7a8a9d;
        }

        .faq-item {
            border-bottom: 1px solid #eef1f5;

            &:last-child {
                border-bottom: none;
            }

            .faq-question {
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 10px;
                padding: 0.8rem 0;
                cursor: pointer;
                font-size: 0.9rem;
                font-weight: bold;
                color: #33475b;

                i {
                    color: #7a8a9d;
                    flex-shrink: 0;
                }
            }

            .faq-answer {
                font-size: 0.85rem;
                color: #666d7a;
                padding: 0 0 0.9rem;
                max-width: 640px;
                white-space: pre-line;
            }
        }
    }
</style>
